import {Component, OnInit} from '@angular/core';
import {EditionService, EditiontQuery} from '../../services/edition.service';
import {CardConditionService} from '../../services/card-condition.service';
import {ToastrService} from 'ngx-toastr';
import {CardQuery, CardService} from '../../services/card.service';
import {Observable} from 'rxjs/Observable';
import {Card, Condition, Edition, Language, ProductDetail, StockRule, Warehouse} from '../../core/entities/entities';
import {WarehouseService} from '../../services/warehouse.service';
import {LanguageService} from '../../services/language.service';
import * as Rx from 'rxjs/Rx';
import {ActivatedRoute, Router} from '@angular/router';
import {ComponentBase} from '../../core/entities/component-base';
import {TypeaheadMatch} from 'ngx-bootstrap';
import {StockRuleService} from '../../services/stock-rule.service';
import {Page} from '../../core/services/HttpServiceBase';

interface StockRuleFilter {
  brandId?: any;
  categoryId?: any;
  holo?: number;
  firstEdition?: boolean;
  signed?: boolean;
  stamped?: boolean;
  inked?: boolean;
  altered?: boolean;
  conditionId?: number;
  status?: any;
  cardId?: any;
  product?: ProductDetail;
  languageId?: any;
  rarityId?: number;
  editionName?: string;
  expansionId?: any;
  warehouseId?: any;
  foil?: boolean;
  warehouse?: Warehouse;
  language?: Language;
  condition?: Condition;
  rarity?: {id:any, name:string};
  expansion?: {
    id: any,
    enName: string;
  };


  minStockQuantity?: number;
  maxStockQuantity?: number;
  productName?: string;
  languageSearchId?: any;
}

@Component({
  selector: 'app-stock-rule',
  templateUrl: './stock-rule.component.html',
  styleUrls: ['./stock-rule.component.css']
})
export class StockRuleComponent extends ComponentBase implements OnInit {

  isCommentDisabled: boolean = true;
  cardMeta: string[] = [/*'hot',*/'foil', 'signed', 'stamped', 'inked', 'altered'];

  card_search: CardQuery = {autocomplete_edition: '', autocomplete_card_name: '', autocomplete_language: this.defaultLanguageId};
  cards: Observable<Card[]>;
  card: Card;

  columns=[
    {label:'name', order: null},//order:'product.enName'},
    {label:'expansion', order: null}, //order:'product.expansion.enName'},
    {label:'warehouse', order: null}, //order:'warehouse.name'},
    {label:'language', order:'combination.language.name'},
    {label:'rarity', order: null}, //order:'product.rarity'},
    {label:'condition', order:'combination.condition.code'},
    //{label:'hot', order:'product.hot'},
    {label:'holo', order:'combination.holo.id'},
    {label:'foil', order:'combination.foil'},
    {label:'firstEdition', order:'combination.firstEdition'},
    {label:'signed', order:'combination.signed'},
    {label:'stamped', order:'combination.stamped'},
    {label:'inked', order:'combination.inked'},
    {label:'altered', order:'combination.altered'},
    {label:'shadowless', order:'combination.shadowless'},
    {label:'staff', order:'combination.staff'},

    {label:'min', order:'minStockQuantity'},
    {label:'max', order:'maxStockQuantity'},
    {label:'minPrice', order: 'minPrice'},
    {label:'maxPrice', order: 'maxPrice'}
  ];

  getName(){
    return 'StockRuleComponent';
  }

  setOrder(field: string){
    this._stockRuleService.setOrder(this.page, field);
    this.setPageIndex(1);
  }

  getOrder(field: string){
    return this._stockRuleService.getOrder(this.page, field);
  }

  private _page: Page<StockRule>;
  get page(): Page<StockRule> {
    return this._page
  }

  get pageIndex() {
    return this.page ? this.page.number +1 : 1;
  }

  isCommentEnabled(){
    this.isCommentDisabled = !this.isCommentDisabled;
  }

  set pageIndex(num: number) {
    if(this.pageIndex == num) return;
    this.setPageIndex(num);
  }

  private setPageIndex(num: number){
    this.spinnerService.show();
    this._stockRuleService.toPage(this.page, num-1).subscribe(ret => { this._page = ret; this.saveStorage('page', ret);  this.spinnerService.hide();});
  }

  selectCard(event: TypeaheadMatch) {
    if (event && event.item) {
      this.card = event.item;
      this.card_search.autocomplete_card_name = this.card.name;
      this.card_search.autocomplete_edition = this.card.edition;
      this.filters.cardId = this.card.id;
    }
  }

  eraseCard() {
    this.card_search.autocomplete_edition = '';
    this.filters.cardId = null;
    this.card = null;

    this.saveStorage('card', this.card);
  }

  selectEdition(event: TypeaheadMatch) {
    if ( event && event.item ) {
      this.edition = event.item;
      this.edition_search.edition_name =  this.edition.name;
      this.filters.expansionId = this.edition.id;
    }
  }

  eraseEdition() {
    this.edition_search.edition = null;
    this.filters.expansionId = null;
    this.edition =null;

    this.saveStorage('edition', this.edition);
  }

  edition_search: EditiontQuery = {edition_name:'', type: 0, wh_id: null};
  editions: Rx.Observable<Edition[]>;
  edition: Edition;

  get rules(): Observable<StockRule[]>{
    return this._stockRuleService.dataChange;
  }

  get warehouses() {
    return Observable.create((observer: any) => {
      this._warehouseService.dataChange.subscribe(ret => observer.next(ret.filter(w => !w.refill)));
    });
  };

  get languages() {
    return this._languageService.dataChange;
  };

  get conditions() {
    return this._cardConditionService.dataChange;
  };

  defaultFilters: StockRuleFilter = { languageSearchId : this.constants.defaultLanguageId};

  filters:StockRuleFilter = Object.assign({}, this.defaultFilters);

  constructor(private _stockRuleService: StockRuleService,
              private _route: ActivatedRoute,
              private _languageService: LanguageService,
              private _warehouseService: WarehouseService,
              private _cardConditionService: CardConditionService,
              private _cardService: CardService,
              private _editionServ: EditionService,
              private _router: Router,
              private _toastrService: ToastrService) {
    super();
  }

  ngOnInit() {
    const me = this;
    this.spinnerService.show();
    this.cards = Rx.Observable.create((observer: any) => {
      observer.next(this.card_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._cardService.search({...term, categoryId: this.categoryId, brandId: this.brandId});
      });

    this.editions = Rx.Observable.create((observer: any) => {
      observer.next(this.edition_search);
    }).debounceTime(150)
      .distinctUntilChanged()
      .switchMap((term) => {
        return this._editionServ.search({...term, brandId: this.brandId });
      });


    this.filters = Object.assign({}, this.defaultFilters, this.getStorage('filters'));
    this.productStructureChange.subscribe( () => this.prepareFilters());

    let card = this.getStorage('card');
    if(card )
      this.selectCard(new TypeaheadMatch(Object.assign(new Card(), card)));

    let edition = this.getStorage('edition');
    if(edition )
      this.selectEdition(new TypeaheadMatch(Object.assign(new Edition(), edition)));

    let page =  this.getStorage('page');
    if(page){
      this._page= page;
      me.setPageIndex(me.pageIndex);
    }else {
      me.applyFilters();
    }
  }

  clearFilters() {
    this.eraseCard();
    this.eraseEdition();
    this.filters = Object.assign({}, this.defaultFilters);
    this.saveStorage('filters', this.filters);
    this.edition_search.edition = null;
    this.edition_search.edition_name = null;
    this.card_search.autocomplete_card_name = '';
  }

  prepareFilters(): StockRuleFilter {
    const ret = Object.assign({}, this.filters);

    if(ret.cardId){
      ret.productName = null;
      ret.languageSearchId = null;
    } else if( this.card_search.autocomplete_card_name && this.card_search.autocomplete_card_name.length > 0) {
      ret.productName = this.card_search.autocomplete_card_name;
      ret.languageSearchId = this.card_search.autocomplete_language;
    } else {
      ret.productName = null;
      ret.languageSearchId = null;
    }

    if (!this.isEnabledStructure('language')) ret.languageId = null;
    if (!this.isEnabledStructure('condition')) ret.conditionId = null;
    if (!this.isEnabledStructure('rarity')) ret.rarity = null;
    if (!this.isEnabledStructure('expansion')) ret.expansionId = null;
    if (!this.isEnabledStructure('holo')) ret.holo = null;
    if (!this.isEnabledStructure('altered')) ret.altered = null;
    if (!this.isEnabledStructure('foil')) ret.foil = null;
    if (!this.isEnabledStructure('signed')) ret.signed = null;
    if (!this.isEnabledStructure('stamped')) ret.stamped = null;
    if (!this.isEnabledStructure('firstEdition')) ret.firstEdition = null;
    if (!this.isEnabledStructure('inked')) ret.inked = null;

    ret.brandId = this.brandId;
    ret.categoryId = this.categoryId;

    this.saveStorage('filters', ret);
    this.saveStorage('card', this.card);
    this.saveStorage('edition', this.edition);
    return ret;
  }

  applyFilters() {
    this._page = null;
    this._stockRuleService.search(this.prepareFilters()).subscribe(ret => { this._page = ret; this.saveStorage('page', ret);  this.spinnerService.hide(); });
  }

  detail(p: StockRule){
    this.spinnerService.show();
    this._router.navigateByUrl('/home/stock_rule/' + p.id);
  }

  add() {
    this.spinnerService.show();
    this._router.navigateByUrl('/home/stock_rule_add');
  }

  private hasCheck: boolean;
  private allCheckStatus: boolean;

  get hasSelection() : boolean {
    return this.hasCheck;
  }
  allcheckStatus(){
    var me = this;
    return {
      get checked(){
        return me.allCheckStatus;
      },
      set checked(val: boolean){
        me.checkAll(val);
      }
    }
  }

  checkAll(val : boolean){
    this.allCheckStatus = val;
    this.saveCheckStatus(this._page.content, val);

  }

  saveCheckStatus(data: StockRule[], val: boolean) {
    if(data){
      data.forEach(od => od.selected = val);
    }
    this.loadAllCheckStatus();

  }

  private loadAllCheckStatus(){
    this.hasCheck =  this._page.content != null && this._page.content.length > 0 && this._page.content.some( od => od.selected);
    this.allCheckStatus =  this._page.content.every( od => od.selected);
  }

  checkStatus(od: StockRule ){
    var me = this;
    return {
      get checked(){
        return od.selected;
      },
      set checked(val: boolean){
        od.selected = val;
        me.loadAllCheckStatus();
      }
    }
  }

  removeAll(){
    const me = this;
    const obsList = this._page.content.filter( pr => pr.selected).map( pr =>  me._stockRuleService.remove( pr));
    if(obsList.length > 0) {
      this.spinnerService.show();
    }
    Observable.zip(...obsList).subscribe( ret =>
    {
      me._toastrService.success('Eseguito Correttamente!');
      me.applyFilters();
      me.allcheckStatus().checked = false;

    });
  }


}



// WEBPACK FOOTER //
// ./src/app/conf/stock-rule/stock-rule.component.ts